import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function LockOpenIcon(props) {
	return (
		<IconBase type="lock-open" {...props}>
			<path d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z" />
		</IconBase>
	);
}
LockOpenIcon.propTypes = iconPropTypes;
